/** Shared FullCalendar interaction tuning for touch drag. */
export const CALENDAR_DRAG_PROPS = {
  eventLongPressDelay: 350,
  eventDragMinDistance: 8,
} as const;

/** Pointer position from mouse or touch end events. */
export function pointerCoords(
  jsEvent: MouseEvent | TouchEvent | Event,
): { x: number; y: number } {
  if ('changedTouches' in jsEvent && jsEvent.changedTouches.length > 0) {
    const touch = jsEvent.changedTouches[0]!;
    return { x: touch.clientX, y: touch.clientY };
  }
  if ('clientX' in jsEvent) {
    return { x: jsEvent.clientX, y: jsEvent.clientY };
  }
  return { x: 0, y: 0 };
}

/** True when coordinates resolve to a real hit-test point (not a missing touch end). */
export function hasPointerCoords(jsEvent: MouseEvent | TouchEvent | Event): boolean {
  if ('changedTouches' in jsEvent) return jsEvent.changedTouches.length > 0;
  if ('clientX' in jsEvent) return jsEvent.clientX !== 0 || jsEvent.clientY !== 0;
  return false;
}

/** Defer work until after FullCalendar finishes the drop gesture. */
export function afterCalendarGesture(fn: () => void): void {
  requestAnimationFrame(() => requestAnimationFrame(fn));
}
